import type { DocumentOrderBy } from "@common/client"
import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "title",
  "revision",
  "issued_by",
  "ata",
  "superseded_by",
  "added",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const FIXED_COLUMNS: Column[] = ["title"]

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Document",
  title: "Title",
  revision: "Revision",
  issued_by: "Issued by",
  ata: "ATA",
  superseded_by: "Superseded by",
  added: "Uploaded",
}

export const SORT_KEYS: Partial<Record<Column, DocumentOrderBy>> = {
  number: "document_number",
  title: "title",
  ata: "ata_chapter",
  added: "created_at",
}

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "documents",
  widths: {
    select: 2.25,
    number: 9,
    title: 16,
    revision: 6,
    issued_by: 9,
    ata: 5,
    superseded_by: 8,
    added: 6.5,
    actions: 4,
  },
  fill: "title",
  pinned: ["select", "actions"],
  extras: ["select", "actions"],
  dropOrder: ["revision", "added", "ata", "issued_by", "superseded_by"],
}

export type Slot = Column | "select" | "actions"

export function withFixed(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => FIXED_COLUMNS.includes(column) || columns.includes(column),
  )
}

export function slotsOf(columns: Column[]): Slot[] {
  return ["select", ...withFixed(columns), "actions"]
}
